import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import { getCurrencyByLocale } from '@/src/utils/currency/formatCurrency'
import useFormatCurrency from '../useFormatCurrency'

const useFormatCurrencyForItinerary = () => {
    const itineraryId = useGetItineraryId()
    const { formatCurrency } = useFormatCurrency()
    const { currencyConversionDetails } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => {
                return {
                    currencyConversionDetails: data?.currencyConversionDetails
                }
            }
        }
    )
    const formatCurrencyForItinerary = (price: number, usePrecision: boolean = true) => {
        const { buffer = 1, rate = 1, to: toCurrency = '' } = currencyConversionDetails || {}
        return formatCurrency({
            toCurrency,
            rate,
            buffer,
            price,
            usePrecision
        })
    }

    // The currency the amounts passed to `formatCurrency` are expected to be in — the domain's
    // own currency, which is what the rate converts *from*. Callers that hold a hardcoded price
    // (rather than one the API already returned in this currency) need it to pick the right one.
    const baseCurrency = currencyConversionDetails?.from || getCurrencyByLocale()?.currency || ''

    return {
        formatCurrency: formatCurrencyForItinerary,
        baseCurrency
    }
}

export default useFormatCurrencyForItinerary
